import React from 'react';
import { reportFrontendError } from './reportFrontendError';

interface FrontendErrorBoundaryProps {
  applicationName: string;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

interface FrontendErrorBoundaryState {
  hasError: boolean;
}

export class FrontendErrorBoundary extends React.Component<
  FrontendErrorBoundaryProps,
  FrontendErrorBoundaryState
> {
  public constructor(props: FrontendErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(): FrontendErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    void reportFrontendError({
      applicationName: this.props.applicationName,
      eventType: 'react_error_boundary',
      message: error.message,
      stack: error.stack ?? '',
      componentStack: errorInfo.componentStack ?? '',
      route: window.location.pathname,
      url: window.location.href,
      userAgent: window.navigator.userAgent,
    });
  }

  public render(): React.ReactNode {
    if (this.state.hasError) {
      return this.props.fallback ?? <div>Something went wrong.</div>;
    }
    return this.props.children;
  }
}
